// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4rbIz","subtitle":"styles_subtitle__7qItV","challengeName":"styles_challengeName__MmxT0","buttonLink":"styles_buttonLink__P9CFh"};